export enum ExitIntentAreas {
  TopLeft = 'TopLeft',
  TopRight = 'TopRight',
  LeftTop = 'LeftTop',
  RightTop = 'RightTop',
  LeftBottom = 'LeftBottom',
  RightBottom = 'RightBottom',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
}
